// @generated by protobuf-ts 2.9.4 with parameter generate_dependencies,optimize_code_size
// @generated from protobuf file "core/v1/value_source.proto" (package "core.v1", syntax proto3)
// tslint:disable
import { MessageType } from "@protobuf-ts/runtime";
import { Value } from "../../google/protobuf/struct";
import { Timestamp } from "../../google/protobuf/timestamp";
import { Date } from "./date";
/**
 * Where a stored value came from (architecture-redesign.md item J §1). Held in Family.field_sources,
 * keyed by field path: dotted proto field names, list items addressed by uuid, e.g.
 * "persons[<uuid>].tfsa_accounts[<uuid>].current_value". A path with no entry is either unknown
 * (no value stored; the engine defaults it each run) or predates value sources (treated as USER).
 *
 * @generated from protobuf message core.v1.ValueSource
 */
export interface ValueSource {
    /**
     * @generated from protobuf field: core.v1.ValueSource.Source source = 1;
     */
    source: ValueSource_Source;
    /**
     * @generated from protobuf field: core.v1.Date as_of = 2;
     */
    asOf?: Date; // the date the value was true on (balances, room); defaults to Family.facts_as_of
    /**
     * @generated from protobuf field: google.protobuf.Timestamp recorded_at = 3;
     */
    recordedAt?: Timestamp;
    /**
     * CONFIRMED only: the newer default the user was offered and declined ("keep mine"). The question
     * comes back only if the default moves again.
     *
     * @generated from protobuf field: google.protobuf.Value declined_default = 4;
     */
    declinedDefault?: Value;
}
/**
 * @generated from protobuf enum core.v1.ValueSource.Source
 */
export enum ValueSource_Source {
    /**
     * @generated from protobuf enum value: SOURCE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * entered by the user
     *
     * @generated from protobuf enum value: SOURCE_USER = 1;
     */
    USER = 1,
    /**
     * the user accepted our default
     *
     * @generated from protobuf enum value: SOURCE_CONFIRMED = 2;
     */
    CONFIRMED = 2,
    /**
     * the engine's prediction, confirmed by the user at a check-in
     *
     * @generated from protobuf enum value: SOURCE_PLAN_REFRESH = 3;
     */
    PLAN_REFRESH = 3,
    /**
     * imported from a CSV file
     *
     * @generated from protobuf enum value: SOURCE_CSV = 4;
     */
    CSV = 4,
    /**
     * imported from Flinks
     *
     * @generated from protobuf enum value: SOURCE_FLINKS = 5;
     */
    FLINKS = 5,
    /**
     * imported from Wealthica
     *
     * @generated from protobuf enum value: SOURCE_WEALTHICA = 6;
     */
    WEALTHICA = 6
}
/**
 * A field path plus a message, used for engine validation results.
 *
 * @generated from protobuf message core.v1.FieldError
 */
export interface FieldError {
    /**
     * @generated from protobuf field: string path = 1;
     */
    path: string;
    /**
     * @generated from protobuf field: string message = 2;
     */
    message: string;
    /**
     * @generated from protobuf field: core.v1.FieldError.Code code = 3;
     */
    code: FieldError_Code;
}
/**
 * A machine-readable kind for errors the app answers with something other than the message.
 *
 * @generated from protobuf enum core.v1.FieldError.Code
 */
export enum FieldError_Code {
    /**
     * @generated from protobuf enum value: CODE_UNSPECIFIED = 0;
     */
    UNSPECIFIED = 0,
    /**
     * A household save (ApplyQuestionnaireRequest.household_save) whose FHSA (path
     * `persons[<uuid>].fhsa_accounts[<uuid>]`) belongs to someone who isn't a first-time home buyer, without
     * FHSAAccount.transfer_to_rrsp_confirmed. Resolved by marking the holder a first-time home buyer, by
     * confirming the move to the RRSP, or by changing the data.
     *
     * @generated from protobuf enum value: CODE_FHSA_TRANSFER_UNCONFIRMED = 1;
     */
    FHSA_TRANSFER_UNCONFIRMED = 1
}
/**
 * A default whose current value differs from a value the user confirmed earlier.
 *
 * @generated from protobuf message core.v1.DefaultChange
 */
export interface DefaultChange {
    /**
     * @generated from protobuf field: string path = 1;
     */
    path: string;
    /**
     * @generated from protobuf field: google.protobuf.Value confirmed_value = 2;
     */
    confirmedValue?: Value;
    /**
     * @generated from protobuf field: google.protobuf.Value current_default = 3;
     */
    currentDefault?: Value;
}
// @generated message type with reflection information, may provide speed optimized methods
class ValueSource$Type extends MessageType<ValueSource> {
    constructor() {
        super("core.v1.ValueSource", [
            { no: 1, name: "source", kind: "enum", T: () => ["core.v1.ValueSource.Source", ValueSource_Source, "SOURCE_"] },
            { no: 2, name: "as_of", kind: "message", T: () => Date },
            { no: 3, name: "recorded_at", kind: "message", T: () => Timestamp },
            { no: 4, name: "declined_default", kind: "message", T: () => Value }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.ValueSource
 */
export const ValueSource = new ValueSource$Type();
// @generated message type with reflection information, may provide speed optimized methods
class FieldError$Type extends MessageType<FieldError> {
    constructor() {
        super("core.v1.FieldError", [
            { no: 1, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "message", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "code", kind: "enum", T: () => ["core.v1.FieldError.Code", FieldError_Code, "CODE_"] }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.FieldError
 */
export const FieldError = new FieldError$Type();
// @generated message type with reflection information, may provide speed optimized methods
class DefaultChange$Type extends MessageType<DefaultChange> {
    constructor() {
        super("core.v1.DefaultChange", [
            { no: 1, name: "path", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "confirmed_value", kind: "message", T: () => Value },
            { no: 3, name: "current_default", kind: "message", T: () => Value }
        ]);
    }
}
/**
 * @generated MessageType for protobuf message core.v1.DefaultChange
 */
export const DefaultChange = new DefaultChange$Type();
